import { useTranslation } from 'react-i18next';
import { SUPPORT_BOT_URL } from '../ton/config';

interface LegalLinksProps {
  className?: string;
}

export function LegalLinks({ className = '' }: LegalLinksProps) {
  const { t } = useTranslation();

  return (
    <nav className={`legal-links ${className}`.trim()} aria-label={t('legal.aria')}>
      <a href="/terms">{t('legal.terms')}</a>
      <span aria-hidden="true">·</span>
      <a href="/privacy">{t('legal.privacy')}</a>
      <span aria-hidden="true">·</span>
      <a href={SUPPORT_BOT_URL} target="_blank" rel="noreferrer">
        {t('legal.support')}
      </a>
    </nav>
  );
}
